import type { GuideStatus } from "../types/guide";
import type { CourseStatus } from "../types/course";

export function StatusBadge({ status, enabled }: { status: GuideStatus | CourseStatus; enabled?: boolean }) {
  const label = enabled === false ? "disabled" : status;
  const cls = enabled === false ? "disabled" : status;
  return <span className={`badge badge-${cls}`}>{label.replace("_", " ")}</span>;
}
